<template>
    <v-dialog v-model="internalDialog" max-width="600">
        <v-card>
            <v-card-title class="headline">Payment Confirmation</v-card-title>
            <v-card-text>
                <v-data-table
                        :headers="headers"
                        :items="paymentsToPay"
                        hide-default-footer
                        :hide-default-header="true"
                        class="elevation-1"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <thead>
                        <tr>
                            <th v-for="h in headers">
                                <span style="color: black">{{h.text}}</span>
                            </th>
                        </tr>
                        </thead>
                    </template>
                    <template #item.affiliate="{ item }">
                        <span>{{ `${item.affiliateName} (${item.affiliate_id})` }}</span>
                    </template>
                    <template #item.confirm="{ item, index }">
                        <v-text-field
                                v-model.number="paymentsToPay[index].confirm"
                                type="number"
                                hide-details
                                dense
                                solo
                                flat
                                class="no-border"
                        />
                    </template>
                </v-data-table>
            </v-card-text>

            <v-card-actions class="justify-end btn-section">
                <v-btn text @click="close">Cancel</v-btn>
                <v-btn color="primary" @click="submit" :disabled="hasInvalidConfirm">Pay</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'PaymentConfirmationModal',
        props: {
            value: Boolean,
            payments: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                paymentsToPay: [],
                headers: [
                    { text: 'Affiliate', value: 'affiliate', sortable: false },
                    { text: 'Balance', value: 'balance',  sortable: false },
                    { text: 'Confirm Amount', value: 'confirm',  sortable: false },
                ],
            };
        },
        computed: {
            internalDialog: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },
            hasInvalidConfirm() {
                return this.paymentsToPay.some(p => p.confirm > p.balance);
            },
        },
        watch: {
            payments: {
                handler(newVal) {
                    this.paymentsToPay = newVal.map(p => ({...p, confirm: p.balance,}));
                },
                immediate: true,
            },
        },
        methods: {
            close() {
                this.internalDialog = false;
            },
            submit() {
                const payments =  this.paymentsToPay.map(i => ({...{id: i.id, payAmount: i.confirm}}));
                this.$emit('confirm', payments);
                this.close();
            },
        },
    };
</script>

<style scoped lang="sass">
    .headline
        font-weight: bolder
        margin-bottom: 2%
        margin-top: 2%
        color: var(--v-primary-base)
    .btn-section
        padding-bottom: 3% !important
</style>
